import React, { Fragment, FunctionComponent, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { identifyAnalytics, trackEvent } from '../../../api/Pendo';
import { AuthenticationType } from '../../../api/AuthenticationType';

const Auth0PendoIdentifyAnalytics: FunctionComponent = (props) => {
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user) {
      identifyAnalytics({
        email: user.email || '',
        userId: user.sub || '',
      });
      trackEvent('UserAuthenticated', { authProvider: AuthenticationType.AUTH0 });
    }
  }, [isAuthenticated, user]);

  return <Fragment>{props.children}</Fragment>;
};

export { Auth0PendoIdentifyAnalytics };
